import { RESTDataSource } from "@apollo/datasource-rest";
import config from "@/lib/config";

class SearchConfig extends RESTDataSource {
  async getSearchConfig() {
    return this.get( config.s3Url );
  }
}
export default SearchConfig;
